import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'numeric-keyboard',
	templateUrl: './numeric-keyboard.component.html',
	styleUrls: ['./numeric-keyboard.component.css'],
})
export class NumericKeyboardComponent implements OnInit {
    @Output() action = new EventEmitter();
    
    ngOnInit() {
        //
    }
    
    clickKeyboard(key){
        this.action.emit(key);
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/controls/numeric-keyboard/numeric-keyboard.component.ts